module.exports = __webpack_public_path__ + "static/media/collect_empty.f9ab0b18.png";